import React from "react"
import BoundedInput from "../../../InputForm/BoundedForm"

class RevenueFormComponent extends React.Component {

	render() {
    const ids          = {
			name        : "ppi-revenue-name",
		}

		return (
			<form onSubmit={this.props.onSubmit}>
				{ this.props.delete
					? <div>Êtes-vous sûr de vouloir supprimer la recette <strong>{this.props.revenue.name}</strong> ?</div>
					: <div className="columns is-desktop">
							<div className="column">
								<div className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.name}>Nom de la recette</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<BoundedInput
													className   = "input"
													id          = {ids.name}
													name        = "name"
													type="text"
													min="0"
													max="30"
													onChange    = {this.props.onNameChange}
													placeholder = "Nom de la recette"
													value       = {this.props.name}
													recommendedMax="30"
													required />
											</span>
										</span>
									</span>
								</div>
							</div>
						</div>
				}
				<div className="columns">
					{/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							{this.props.delete ? "Supprimer" : (this.props.revenue ? "Modifier" : "Ajouter")} la recette
						</button>
					</div>
				</div>
			</form>
		)
	}

}

export default RevenueFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/revenues/form-component.js